export default "__VITE_ASSET__B5VOJJJA__"